// Linking a Me person to a trameria account, as cloud offers it: the members
// of the workspaces the person is in (the server links exactly those, and the
// person themself never). Given to `personsScreen({ link })`.
import { useQueries, useQuery } from "@tanstack/react-query";
import {
  fileUrl,
  type LinkAccount,
  type PersonsExtensions,
  useApi,
  useMeApp,
} from "@trameria/ui-core";
import { accountQuery } from "./queries";
import { membersQuery, workspacesQuery } from "./workspace/queries";

/** Everyone the person shares a workspace with, once each (null while loading). */
function useLinkAccounts(): readonly LinkAccount[] | null {
  const api = useApi();
  const { apiBase } = useMeApp();
  const me = useQuery(accountQuery(api));
  const workspaces = useQuery(workspacesQuery(api));
  const members = useQueries({
    queries: (workspaces.data ?? []).map((w) => membersQuery(api, w.slug)),
  });
  if (!me.data || !workspaces.data || members.some((q) => !q.data)) return null;
  const seen = new Map<string, LinkAccount>();
  for (const q of members)
    for (const x of q.data ?? [])
      if (x.userId !== me.data.userId && !seen.has(x.userId))
        seen.set(x.userId, {
          userId: x.userId,
          name: x.displayName,
          image: x.avatarFileId ? fileUrl(apiBase, x.avatarFileId) : null,
        });
  return [...seen.values()].sort((a, b) => a.name.localeCompare(b.name));
}

export const personLink: PersonsExtensions = {
  link: { useAccounts: useLinkAccounts },
};
